import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../utils/grid/Grid';
import HostTeaserBig from './HostTeaserBig';

import './host-teaser-list.css';

const HostTeaserSearchList = ({ hosts, className }) => (
  <Row className={className}>
    {hosts.map((host, index) => (
      <Col xs={12} key={index} className="host-teaser-list search-teaser">
        <HostTeaserBig linkTarget="_blank" {...host} />
      </Col>
    ))}
  </Row>
);

HostTeaserSearchList.propTypes = {
  hosts: PropTypes.arrayOf(PropTypes.shape(HostTeaserBig.propTypes)).isRequired,
  className: PropTypes.string,
};

export default HostTeaserSearchList;
